import { all, fork, takeLatest } from 'redux-saga/effects';
import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_BODY_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SHOW_RIGHT_SIDEBAR,
} from '../../types/layout';

import {
  changeLayoutWorker,
  changeLayoutWidthWorker,
  changeLeftSidebarThemeWorker,
  changeBodyThemeWorker,
  changeLeftSidebarTypeWorker,
  changeTopbarThemeWorker,
  showRightSidebarWorker,
} from '../workers/layoutWorker';

/**
 * Watcher for layout changes
 */
function* watchChangeLayout() {
  yield takeLatest(CHANGE_LAYOUT, changeLayoutWorker);
}

/**
 * Watcher for layout width changes
 */
function* watchChangeLayoutWidth() {
  yield takeLatest(CHANGE_LAYOUT_WIDTH, changeLayoutWidthWorker);
}

/**
 * Watcher for left sidebar theme changes
 */
function* watchChangeLeftSidebarTheme() {
  yield takeLatest(CHANGE_SIDEBAR_THEME, changeLeftSidebarThemeWorker);
}

/**
 * Watcher for body theme changes
 */
function* watchChangeBodyTheme() {
  yield takeLatest(CHANGE_BODY_THEME, changeBodyThemeWorker);
}

/**
 * Watcher for left sidebar type changes
 */
function* watchChangeLeftSidebarType() {
  yield takeLatest(CHANGE_SIDEBAR_TYPE, changeLeftSidebarTypeWorker);
}

/**
 * Watcher for topbar theme changes
 */
function* watchChangeTopbarTheme() {
  yield takeLatest(CHANGE_TOPBAR_THEME, changeTopbarThemeWorker);
}

/**
 * Watcher for right sidebar visibility changes
 */
function* watchShowRightSidebar() {
  yield takeLatest(SHOW_RIGHT_SIDEBAR, showRightSidebarWorker);
}

/**
 * Root layout saga
 */
function* layoutSaga() {
  yield all([
    fork(watchChangeLayout),
    fork(watchChangeLayoutWidth),
    fork(watchChangeLeftSidebarTheme),
    fork(watchChangeBodyTheme),
    fork(watchChangeLeftSidebarType),
    fork(watchChangeTopbarTheme),
    fork(watchShowRightSidebar),
  ]);
}

export default layoutSaga;
